import APIClient from '@/shared/http/clients/api'

const resourceName = 'blacklist/whatsapp'
const APICore = process.env.APIBaseURLCore

const GetAllPaging = (config = {}) => APIClient.get(`${APICore}/${resourceName}/listBlackList`, config)
const Search = (date = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?data=${date}&page=${index}&size=${limit}`, config)
const Delete = (id) => APIClient.delete(`${APICore}/${resourceName}/${id}`)

const BlackListRepository = {
  GetAllPaging,
  Search,
  Delete
}

export default BlackListRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/blacklist/blacklist.js